/**
 * About Euhomy 2 — Globe Stats
 * 静态宽幅地球布局；进入视口播放数字滚动；双视频硬切循环避免黑帧闪动
 */
(function () {
  'use strict';

  var COUNT_DURATION = 1.25;
  var COUNT_STAGGER = 0.08;
  var COUNT_EASE = 'power2.out';
  /* 片尾提前切到待命层；硬切不做半透明 crossfade */
  var LOOP_SWAP_LEAD = 0.6;
  var SWAP_HOLD_MS = 80;

  function q(root, sel) {
    return root ? root.querySelector(sel) : null;
  }

  function qa(root, sel) {
    return root ? Array.from(root.querySelectorAll(sel)) : [];
  }

  function parseNum(val, fallback) {
    var n = parseFloat(val);
    return Number.isFinite(n) ? n : fallback;
  }

  function formatStatValue(value, decimals) {
    if (decimals <= 0) return String(Math.round(value));
    return value.toFixed(decimals);
  }

  function readStatParts(stat) {
    return {
      target: parseNum(stat.getAttribute('data-value'), 0),
      prefix: stat.getAttribute('data-prefix') || '',
      suffix: stat.getAttribute('data-suffix') || '',
      decimals: parseInt(stat.getAttribute('data-decimals') || '0', 10) || 0,
      valueEl: q(stat, '[data-ae2-globe-stat-value]'),
    };
  }

  function setStatText(parts, value) {
    if (!parts.valueEl) return;
    parts.valueEl.textContent = parts.prefix + formatStatValue(value, parts.decimals) + parts.suffix;
  }

  function resetStatsToZero(stats) {
    stats.forEach(function (stat) {
      setStatText(readStatParts(stat), 0);
    });
  }

  function tryPlayVideo(video) {
    if (!video) return;
    var p = video.play();
    if (p && typeof p.catch === 'function') p.catch(function () { /* noop */ });
  }

  function afterPaint(fn) {
    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(fn);
    });
  }

  function setupSeamlessVideoLoop(root) {
    var wrap = q(root, '[data-ae2-globe-video-wrap]');
    var primary = q(root, '.ae2-globe__video:not(.ae2-globe__video--clone)');
    if (!wrap || !primary) return function () {};

    if (wrap.getAttribute('data-ae2-seamless-loop') === '1') {
      tryPlayVideo(primary);
      return function () {};
    }
    wrap.setAttribute('data-ae2-seamless-loop', '1');

    primary.muted = true;
    primary.setAttribute('muted', '');
    primary.setAttribute('playsinline', '');
    primary.setAttribute('webkit-playsinline', '');
    primary.removeAttribute('poster');

    /*
      CDN / Files 直链常为 4K 原片：双层无缝会同时解码两路高码率视频，极易卡顿。
      直链走原生 loop（与「流畅循环」一致）；Shopify 视频选择器仍用双层硬切消黑帧。
    */
    if (primary.hasAttribute('data-ae2-globe-direct-url')) {
      primary.loop = true;
      primary.setAttribute('loop', '');
      primary.style.opacity = '1';
      primary.style.visibility = 'visible';

      function onDirectLoaded() {
        tryPlayVideo(primary);
      }

      primary.addEventListener('loadeddata', onDirectLoaded);
      primary.addEventListener('canplay', onDirectLoaded);
      tryPlayVideo(primary);

      return function () {
        primary.removeEventListener('loadeddata', onDirectLoaded);
        primary.removeEventListener('canplay', onDirectLoaded);
        wrap.removeAttribute('data-ae2-seamless-loop');
      };
    }

    primary.loop = false;
    primary.removeAttribute('loop');
    primary.classList.add('ae2-globe__video--primary');
    primary.style.opacity = '1';
    primary.style.visibility = 'visible';
    primary.style.zIndex = '2';

    var clone = primary.cloneNode(true);
    clone.classList.add('ae2-globe__video--clone');
    clone.removeAttribute('id');
    clone.loop = false;
    clone.removeAttribute('loop');
    clone.muted = true;
    clone.setAttribute('muted', '');
    clone.setAttribute('playsinline', '');
    clone.setAttribute('webkit-playsinline', '');
    clone.preload = 'auto';
    clone.style.opacity = '0';
    clone.style.visibility = 'hidden';
    clone.style.zIndex = '1';
    clone.style.pointerEvents = 'none';
    /* 去掉原生 poster，避免切换时闪原生封面 */
    clone.removeAttribute('poster');
    wrap.appendChild(clone);

    /* clone 后强制重新 load，确保 source 开始缓冲 */
    try {
      if (typeof clone.load === 'function') clone.load();
    } catch (err) { /* noop */ }

    var active = primary;
    var standby = clone;
    var switching = false;
    var disposed = false;

    function prepareStandby(cb) {
      var done = false;
      var fallbackTimer = null;

      function finish() {
        if (done || disposed) return;
        done = true;
        standby.removeEventListener('seeked', onSeeked);
        standby.removeEventListener('playing', onPlaying);
        if (fallbackTimer) window.clearTimeout(fallbackTimer);
        if (typeof cb === 'function') cb();
      }

      function onPlaying() {
        afterPaint(finish);
      }

      function onSeeked() {
        tryPlayVideo(standby);
        if (!standby.paused && standby.readyState >= 2) {
          afterPaint(finish);
          return;
        }
        standby.addEventListener('playing', onPlaying);
      }

      try {
        standby.pause();
        standby.style.opacity = '0';
        /* 保持 hidden 会让部分 iOS 不解码；用 opacity 藏着但 visibility visible */
        standby.style.visibility = 'visible';

        if (standby.readyState >= 2 && Math.abs(standby.currentTime - 0.001) < 0.08) {
          tryPlayVideo(standby);
          standby.addEventListener('playing', onPlaying);
          if (!standby.paused) afterPaint(finish);
        } else {
          standby.addEventListener('seeked', onSeeked);
          standby.currentTime = 0.001;
        }
      } catch (err) {
        tryPlayVideo(standby);
        finish();
        return;
      }

      fallbackTimer = window.setTimeout(finish, 220);
    }

    function revealStandby() {
      if (disposed) return;

      prepareStandby(function () {
        if (disposed) return;

        /* 硬切：先把已在播的待命层置于顶层全显，再藏上一层，全程不透明 */
        tryPlayVideo(standby);
        standby.style.transition = 'none';
        active.style.transition = 'none';
        standby.style.zIndex = '3';
        standby.style.opacity = '1';
        standby.style.visibility = 'visible';

        afterPaint(function () {
          if (disposed) return;
          active.style.opacity = '0';
          active.style.visibility = 'hidden';
          active.style.zIndex = '1';

          window.setTimeout(function () {
            if (disposed) return;
            var prev = active;
            active = standby;
            standby = prev;
            standby.pause();
            try {
              standby.currentTime = 0.001;
            } catch (err) { /* noop */ }
            standby.style.zIndex = '1';
            switching = false;
          }, SWAP_HOLD_MS);
        });
      });
    }

    function swapLayers() {
      if (disposed || switching) return;
      if (!active.duration || !isFinite(active.duration)) return;
      if (active.currentTime < active.duration - LOOP_SWAP_LEAD) return;

      switching = true;
      revealStandby();
    }

    function onTimeUpdate() {
      swapLayers();
    }

    function onEnded() {
      if (switching || disposed) return;
      switching = true;
      revealStandby();
    }

    primary.addEventListener('timeupdate', onTimeUpdate);
    clone.addEventListener('timeupdate', onTimeUpdate);
    primary.addEventListener('ended', onEnded);
    clone.addEventListener('ended', onEnded);

    tryPlayVideo(primary);
    primary.addEventListener('loadeddata', function () {
      tryPlayVideo(primary);
    }, { once: true });

    return function () {
      disposed = true;
      primary.removeEventListener('timeupdate', onTimeUpdate);
      clone.removeEventListener('timeupdate', onTimeUpdate);
      primary.removeEventListener('ended', onEnded);
      clone.removeEventListener('ended', onEnded);
      if (clone.parentNode) clone.parentNode.removeChild(clone);
      wrap.removeAttribute('data-ae2-seamless-loop');
      primary.loop = true;
      primary.setAttribute('loop', '');
      primary.style.opacity = '';
      primary.style.visibility = '';
      primary.style.zIndex = '';
    };
  }

  function playStatsCount(gsap, stats) {
    return stats.map(function (stat, i) {
      var parts = readStatParts(stat);
      var proxy = { val: 0 };
      setStatText(parts, 0);
      return gsap.to(proxy, {
        val: parts.target,
        duration: COUNT_DURATION,
        delay: i * COUNT_STAGGER,
        ease: COUNT_EASE,
        onUpdate: function () {
          setStatText(parts, proxy.val);
        },
      });
    });
  }

  function createCountController(gsap, stats) {
    var tweens = [];
    var active = false;

    return {
      start: function () {
        if (active) return;
        active = true;
        tweens.forEach(function (tween) {
          if (tween) tween.kill();
        });
        tweens.length = 0;
        tweens.push.apply(tweens, playStatsCount(gsap, stats));
      },
      reset: function () {
        if (!active) return;
        active = false;
        tweens.forEach(function (tween) {
          if (tween) tween.kill();
        });
        tweens.length = 0;
        resetStatsToZero(stats);
      },
      kill: function () {
        active = false;
        tweens.forEach(function (tween) {
          if (tween) tween.kill();
        });
        tweens.length = 0;
      },
    };
  }

  function initSection(ctx, root) {
    var gsap = ctx.gsap;
    var ScrollTrigger = ctx.ScrollTrigger;
    var title = q(root, '[data-ae2-globe-title]');
    var stats = qa(root, '[data-ae2-globe-stat]');
    var videoWrap = q(root, '[data-ae2-globe-video-wrap]');
    var countCtrl = createCountController(gsap, stats);
    var stopLoop = setupSeamlessVideoLoop(root);
    var st = null;

    if (title) gsap.set(title, { clearProps: 'opacity,transform,y' });
    if (stats.length) gsap.set(stats, { clearProps: 'opacity,transform,y' });
    if (videoWrap) gsap.set(videoWrap, { clearProps: 'opacity,transform,y,scale' });

    resetStatsToZero(stats);

    if (ScrollTrigger && stats.length) {
      st = ScrollTrigger.create({
        trigger: root,
        start: 'top 75%',
        once: true,
        onEnter: function () {
          countCtrl.start();
        },
      });
    } else {
      countCtrl.start();
    }

    return function () {
      countCtrl.kill();
      if (st) st.kill();
      if (stopLoop) stopLoop();
    };
  }

  function init(ctx) {
    var root = document.querySelector('[data-ae2-globe]');
    if (!root) return;

    if (ctx.reducedMotion) {
      qa(root, '[data-ae2-globe-stat]').forEach(function (stat) {
        setStatText(readStatParts(stat), readStatParts(stat).target);
      });
      setupSeamlessVideoLoop(root);
      return;
    }

    return initSection(ctx, root);
  }

  if (window.AboutEuhomy2 && typeof window.AboutEuhomy2.register === 'function') {
    window.AboutEuhomy2.register(init);
  }
})();
